var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.737 17.215a.528.528 0 00.745 0 .534.534 0 000-.745L1.982 2.976a.536.536 0 00-.753 0 .541.541 0 000 .745l13.508 13.494zM11.914 4.452H4.62l1.026 1.032h6.077c1.114 0 1.756.581 1.756 1.764v5.592c0 .164-.02.287-.061.417l.957.95c.13-.308.205-.69.205-1.06v-1.032l2.584 2.188c.273.225.574.382.855.382.601 0 .998-.444.998-1.08V6.537c0-.636-.397-1.08-.998-1.08-.28 0-.581.157-.855.383L14.58 8.027v-.936c0-1.668-.998-2.639-2.666-2.639zM4.771 15.69h7.266l-1.025-1.025h-6.05c-1.121 0-1.757-.581-1.757-1.77V6.913L2.105 5.8v7.26c0 1.66.998 2.631 2.666 2.631zm12.906-2.317l-3.097-2.557v-1.49l3.097-2.556c.061-.048.102-.076.164-.076.082 0 .116.062.116.158v6.439c0 .096-.034.164-.116.164-.062 0-.103-.04-.164-.082z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "static/media/cam-off.edfbf7af.svg";
export { SvgCamOff as ReactComponent };